import { createContext, useContext, useState } from "react";

const FileContext = createContext();

export function FileProvider({ children }) {
  const [uploadedFile, setUploadedFile] = useState(null);
  const [fileData, setFileData] = useState({
    tideData: null,
    tideFileName: '',
  });

  return (
    <FileContext.Provider
      value={{ uploadedFile, setUploadedFile, fileData, setFileData }}
    >
      {children}
    </FileContext.Provider>
  );
}

export const useFile = () => useContext(FileContext);
